module.exports = __webpack_public_path__ + "assets/img/slogan-77852692.png";